import { graphql } from 'react-relay';
export const ChangeEditionClearRestrictionsForFreeMutation = graphql`
	mutation ChangeEditionClearRestrictionsForFreeMutation($contentId: ID!) {
		clearRestrictionsForFree(contentId: $contentId) {
			restrictionsHash
		}
	}
`;
